var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-card',[_c('vs-chip',{attrs:{"transparent":"","color":"danger"}},[_c('vs-avatar'),_vm._v("\n            Total visitas "+_vm._s(_vm.visitasgestudiante)+"\n         ")],1),_c('indreporteestudiantepastel')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }